import { render, staticRenderFns } from "./record.vue?vue&type=template&id=16ac0959&scoped=true&"
import script from "./record.vue?vue&type=script&lang=ts&"
export * from "./record.vue?vue&type=script&lang=ts&"
import style0 from "../less/record.less?vue&type=style&index=0&id=16ac0959&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac0959",
  null
  
)

export default component.exports